export default "__VITE_ASSET__21ee8645__"